export default "__VITE_ASSET__DZt3rWXN__"